import CompanyConfigurationServices from "./CompanyConfigurationService";
import { mergeGuestPortalConfig } from "../data/guestPortalDefaults";

const CONFIG_KEY = "guest_portal";

const extractItems = (response) =>
  response?.data?.view?.data ??
  response?.data?.view?.items ??
  response?.data?.items ??
  [];

class GuestPortalService {
  async getConfig(companyId) {
    if (!companyId) {
      return { config: mergeGuestPortalConfig(), configId: null };
    }

    try {
      const response = await CompanyConfigurationServices.getConfigurations(
        companyId,
        CONFIG_KEY
      );
      const items = extractItems(response);
      if (items.length > 0) {
        return {
          config: mergeGuestPortalConfig(items[0].value || {}),
          configId: items[0].id,
        };
      }
    } catch (error) {
      console.error("Guest portal config fetch failed, using defaults:", error);
    }

    return { config: mergeGuestPortalConfig(), configId: null };
  }

  async saveConfig(companyId, value, configId) {
    const payload = { companyId, key: CONFIG_KEY, value };
    if (configId) {
      return CompanyConfigurationServices.updateConfiguration(configId, payload);
    }
    return CompanyConfigurationServices.createConfiguration(payload);
  }
}

const GuestPortalServices = new GuestPortalService();

export default GuestPortalServices;
export { CONFIG_KEY };
